import styled from "styled-components";

export const StyledRatesWrapper = styled.div`
  .rates-head {
    padding: 60px 0 30px;
    display: grid;
    align-items: center;
    grid-template-columns: max-content 175px;
    grid-gap: 20px;
    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
    }
  }
  
  .rates-head_client {
    grid-template-columns: max-content 175px 1fr;
    &__change-service {
      display: inline-grid;
      align-items: center;
      justify-content: end;
    }
    @media screen and (max-width: 992px) {
      grid-template-columns: 100%;
      &__change-service {
        justify-content: start;
      }
    }
  }
  
  .rates-table {
    overflow: auto;
    overflow-scrolling: touch;
    &::-webkit-scrollbar {
      -webkit-appearance: none;
      height: 10px;
      background-color: ${({theme}) => theme.scrollbar.track};
      border-radius: 20px;
    }
    &::-webkit-scrollbar-track{
      background-color: ${({theme}) => theme.scrollbar.track};
      border-radius: 20px;
    }
    &::-webkit-scrollbar-thumb {
      height: 16px;
      border: 2px solid ${({theme}) => theme.scrollbar.track};
      background: ${({theme}) => theme.scrollbar.thumb};
      border-radius: 12px;
    }
    
    &__head, &__row {
      min-width: 1480px;
      width: 100%;
      padding: 0;
    }
    &__col {
      padding: 25px 20px;
    }
    &_col-fixed {
      background-color: ${({theme}) => theme.surface.background};
      position: sticky;
      left: 0;
      z-index: 10;
    }
    &__row:hover {
      .rates-table_col-fixed {
        background-color: ${({theme}) => theme.surface.hover};
      }
    }
    
    @media screen and (max-width: 992px) {
      &__head {
        display: none;
      }
      &__row {
        min-width: 100%;
        margin-bottom: 15px;
        padding: 25px 20px;
        grid-template-columns: repeat(2, 1fr);
        border: 1px solid ${({theme}) => theme.surface.border};
        overflow-x: inherit;
        & > div {
          padding-top: 20px;
          &:before {
            display: block;
          }
        }
      }
      &__col {
        padding: 0;
      }
    }
    @media screen and (max-width: 599px) {
      &__row {
        padding: 15px 10px;
        grid-template-columns: 100%;
      }
    }
  }
`;